import React, { createContext, useContext, useState, useCallback } from 'react';

const NewSessionModalContext = createContext(null);

export const NewSessionModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [prefill, setPrefill] = useState(null);

  const openNewSession = useCallback(({ clientIds = [] } = {}) => {
    setPrefill({ clientIds });
    setIsOpen(true);
  }, []);

  const closeNewSession = useCallback(() => {
    setIsOpen(false);
    setPrefill(null);
  }, []);

  return (
    <NewSessionModalContext.Provider value={{ isOpen, prefill, openNewSession, closeNewSession }}>
      {children}
    </NewSessionModalContext.Provider>
  );
};

export const useNewSessionModal = () => useContext(NewSessionModalContext);
